(function(){
  // === Config ===
  const PAID_GIFT_WRAP_VARIANT_ID = 45402323812540;
  const FREE_GIFT_WRAP_VARIANT_ID = 45402359660732;
  const FREE_THRESHOLD = 200.00;
  const ENSURE_INTERVAL = 5000;
  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  async function addVariantToCart(variantId, quantity, properties) {
    const body = { id: parseInt(variantId, 10), quantity: parseInt(quantity, 10), properties: properties || {} };
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    });
    return res.json();
  }

  async function changeLineItem(line, qty) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: qty })
    });
    return res.json();
  }

  async function removeLineByKey(key) {
    const cart = await getCart();
    const lineIndex = cart.items.findIndex(i => i.key === key);
    if (lineIndex >= 0) {
      return changeLineItem(lineIndex + 1, 0);
    }
    return cart;
  }
  function findGiftWrapItemForVariant(cart, variantId) {
    return cart.items.find(item => {
      if (!item.properties) return false;
      return item.properties.gift_for_variant_id && String(item.properties.gift_for_variant_id) === String(variantId);
    });
  }
  async function getSelectedVariantPrice(form, productHandle) {
    // 1) input[name="id"] with dataset.price
    const idInput = form.querySelector('input[name="id"]');
    if (idInput && idInput.dataset && idInput.dataset.price) {
      const p = parseFloat(idInput.dataset.price);
      if (!isNaN(p)) return p;
    }
    const sel = form.querySelector('select[name="id"]');
    if (sel && sel.selectedOptions && sel.selectedOptions[0] && sel.selectedOptions[0].dataset.price) {
      const p = parseFloat(sel.selectedOptions[0].dataset.price);
      if (!isNaN(p)) return p;
    }
    if (sel) {
      const opt = sel.selectedOptions && sel.selectedOptions[0];
      if (opt && opt.dataset && opt.dataset.price) {
        const p = parseFloat(opt.dataset.price);
        if (!isNaN(p)) return p;
      }
    }
    if (!productHandle) return 0;
    try {
      const res = await fetch(`/products/${productHandle}.js`, { credentials: 'same-origin' });
      if (!res.ok) return 0;
      const productJson = await res.json();
      const selectedId = (idInput && idInput.value) || (sel && sel.value);
      if (selectedId) {
        const v = productJson.variants.find(x => String(x.id) === String(selectedId));
        if (v && typeof v.price === 'number') return v.price / 100;
      }
      if (productJson.variants && productJson.variants[0]) return productJson.variants[0].price / 100;
    } catch (e) {
      console.warn('Could not fetch product JSON to determine variant price', e);
    }
    return 0;
  }
  async function ensureCorrectGiftWrapVariants() {
    try {
      const cart = await getCart();
      const subtotal = cart.items_subtotal_price / 100;
      const useFree = subtotal >= FREE_THRESHOLD;
      const cartItems = Array.isArray(cart.items) ? cart.items.slice() : [];

      for (const item of cartItems) {
        if (item.product_title && item.title && (item.title.toLowerCase().includes('gift') || (item.properties && item.properties.gift_for_variant_id))) {
          const linkedVariantId = item.properties && item.properties.gift_for_variant_id;
          if (!linkedVariantId) continue;

          const isFreeVariantCurrently = String(item.variant_id) === String(FREE_GIFT_WRAP_VARIANT_ID);
          if (useFree && !isFreeVariantCurrently) {
            await addVariantToCart(FREE_GIFT_WRAP_VARIANT_ID, item.quantity, item.properties);
            await changeLineItem(item.line, 0);
          } else if (!useFree && isFreeVariantCurrently) {
            await addVariantToCart(PAID_GIFT_WRAP_VARIANT_ID, item.quantity, item.properties);
            await changeLineItem(item.line, 0);
          }
        }
      }
    } catch (err) {
      console.warn('ensureCorrectGiftWrapVariants error', err);
    }
  }
  function initProductPageGiftWrap() {
    document.querySelectorAll('.product-gift-wrap').forEach(function(block) {
      const checkbox = block.querySelector('.gift-wrap-checkbox');
      const messageArea = block.querySelector('.gift-wrap-message');
      const messageInput = block.querySelector('.gift-message-input');
      const productHandle = block.dataset.productHandle;
      const productId = block.dataset.productId;

      let form = block.closest('form');
      if (!form) {
        form = document.querySelector('form[action^="/cart"]'); // fallback
      }
      if (!form) return;

      function getSelectedVariantId() {
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) return idInput.value;
        const idSelect = form.querySelector('select[name="id"]');
        if (idSelect) return idSelect.value;
        return null;
      }
      checkbox.addEventListener('change', async function() {
        const selectedVariantId = getSelectedVariantId();
        if (!selectedVariantId) {
          console.warn('Could not find product variant id for gift-wrap association.');
        }

        if (checkbox.checked) {
          if (messageArea) messageArea.style.display = 'block';
          const cart = await getCart();
          const cartSubtotal = (cart.items_subtotal_price || 0) / 100;
          const productQtyInput = form.querySelector('input[name="quantity"], input.qty') || form.querySelector('input[type="number"]');
          const qty = productQtyInput ? (parseInt(productQtyInput.value, 10) || 1) : 1;
          const selectedVariantPrice = await getSelectedVariantPrice(form, productHandle);
          const projectedSubtotal = cartSubtotal + (selectedVariantPrice * qty);
          const useFree = projectedSubtotal >= FREE_THRESHOLD;

          const variantToAdd = useFree ? FREE_GIFT_WRAP_VARIANT_ID : PAID_GIFT_WRAP_VARIANT_ID;

          const properties = {
            gift_for_variant_id: selectedVariantId || '',
            gift_for_product_handle: productHandle || '',
            gift_message: messageInput ? messageInput.value : ''
          };

          try {
            await addVariantToCart(variantToAdd, qty, properties);
            await ensureCorrectGiftWrapVariants();
            document.dispatchEvent(new CustomEvent('cart:updated'));
          } catch (e) {
            console.warn('Error adding gift wrap from product page', e);
          }

        } else {
          if (messageArea) messageArea.style.display = 'none';
          const cart = await getCart();
          const gwItem = findGiftWrapItemForVariant(cart, getSelectedVariantId());
          if (gwItem) {
            await changeLineItem(gwItem.line, 0);
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }
        }
      });
      if (messageInput) {
        messageInput.addEventListener('change', async function() {
          if (!checkbox.checked) return;
          const cart = await getCart();
          const gwItem = findGiftWrapItemForVariant(cart, getSelectedVariantId());
          if (gwItem) {
            const variantToAdd = (cart.items_subtotal_price / 100 >= FREE_THRESHOLD) ? FREE_GIFT_WRAP_VARIANT_ID : PAID_GIFT_WRAP_VARIANT_ID;
            const properties = Object.assign({}, gwItem.properties || {}, { gift_message: messageInput.value });
            await addVariantToCart(variantToAdd, gwItem.quantity, properties);
            await changeLineItem(gwItem.line, 0);
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }
        });
      }
      const qtyInput = form.querySelector('input[name="quantity"], input.qty, input[type="number"]');
      if (qtyInput) {
        qtyInput.addEventListener('change', async function() {
          if (!checkbox.checked) return;
          const cart = await getCart();
          const gwItem = findGiftWrapItemForVariant(cart, getSelectedVariantId());
          if (gwItem) {
            const newQty = parseInt(qtyInput.value, 10) || 1;
            await changeLineItem(gwItem.line, newQty);
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }
        });
      }
    });
  }
  async function initCartSync() {
    await ensureCorrectGiftWrapVariants();
    document.addEventListener('cart:updated', async function(){
      await ensureCorrectGiftWrapVariants();
    });
    setInterval(ensureCorrectGiftWrapVariants, ENSURE_INTERVAL);
  }
  document.addEventListener('DOMContentLoaded', function(){
    initProductPageGiftWrap();
    if (window.location.pathname.indexOf('/cart') === 0) {
      initCartSync();
    } else {
      document.addEventListener('cart:updated', ensureCorrectGiftWrapVariants);
    }
  });

})();
